import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import Providers from "@/context/Providers";
import { GlobalAdminProtectedRoute } from "@/components/auth/GlobalAdminProtectedRoute";
import { useHttpsRedirect } from "@/hooks/useHttpsRedirect";
import LoginPage from "@/pages/LoginPage";
import AuthCallbackPage from "@/pages/AuthCallbackPage";
import GlobalAdminLayout from "@/components/layout/GlobalAdminLayout";
import ApiKeysPage from "@/pages/ApiKeysPage";
import ServerConfigsPage from "@/pages/ServerConfigsPage";
import UserManagementPage from "@/pages/UserManagementPage";

function App() {
    useHttpsRedirect();

    return (
        <Providers>
            <Router>
                <Routes>
                    {/* Public routes */}
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/auth/callback" element={<AuthCallbackPage />} />

                    {/* Global Admin protected routes */}
                    <Route
                        path="/"
                        element={
                            <GlobalAdminProtectedRoute>
                                <GlobalAdminLayout />
                            </GlobalAdminProtectedRoute>
                        }
                    >
                        <Route index element={<Navigate to="/api-keys" replace />} />
                        <Route path="api-keys" element={<ApiKeysPage />} />
                        <Route path="server-configs" element={<ServerConfigsPage />} />
                        <Route path="users" element={<UserManagementPage />} />
                    </Route>

                    {/* Catch all */}
                    <Route path="*" element={<Navigate to="/api-keys" replace />} />
                </Routes>
            </Router>

            <ReactQueryDevtools initialIsOpen={false} />
        </Providers>
    );
}

export default App;
